import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import LANGUAGES from '../utils/languages';
/**
 * Assigns (or clears) the structured key metadata (author, language) linked
 * to a discussion - opened either from the composer (attrs.initialMetadata +
 * attrs.onsubmit, discussion doesn't exist yet) or from DiscussionControls
 * on an existing discussion (attrs.discussion + attrs.onsubmit). Mirrors
 * champis-events' EventAssignModal, simplified: two plain optional fields,
 * no upload/validation. attrs.onsubmit(metadata) receives a plain
 * {author, language} object (or null to clear); it may return a Promise
 * (discussion.save()) or nothing (composer just stores it for the pending
 * create request).
 */
export default class KeyMetadataModal extends Modal {
  author = '';
  language = '';
  loading = false;
  errorMessage = null;
  oninit(vnode) {
    super.oninit(vnode);
    const discussion = this.attrs.discussion;
    const initial = discussion && discussion.keyMetadata() || this.attrs.initialMetadata || null;
    this.author = initial && initial.author || '';
    this.language = initial && initial.language || '';
    this.loading = false;
    this.errorMessage = null;
  }
  className() {
    return 'Modal--small KeyMetadataModal';
  }
  title() {
    return app.translator.trans('champis-keys.forum.key_metadata.modal_title');
  }
  content() {
    const t = key => app.translator.trans(`champis-keys.forum.key_metadata.${key}`);
    return m("div", {
      className: "Modal-body"
    }, this.errorMessage && m("div", {
      className: "KeyMetadataModal-error"
    }, this.errorMessage), m("div", {
      className: "KeyMetadataModal-field"
    }, m("label", null, t('author_label'), m("input", {
      className: "FormControl",
      type: "text",
      placeholder: t('author_placeholder'),
      value: this.author,
      oninput: e => {
        this.author = e.target.value;
      }
    }))), m("div", {
      className: "KeyMetadataModal-field"
    }, m("label", null, t('language_label'), m("select", {
      className: "FormControl",
      value: this.language,
      onchange: e => {
        this.language = e.target.value;
      }
    }, m("option", {
      value: ""
    }, t('language_placeholder')), LANGUAGES.map(language => m("option", {
      key: language,
      value: language
    }, language))))), m("div", {
      className: "KeyMetadataModal-footer"
    }, m(Button, {
      className: "Button Button--primary",
      onclick: () => this.submit(),
      loading: this.loading
    }, t('save_button')), this.attrs.discussion && m(Button, {
      className: "Button Button--link",
      onclick: () => this.submitDelete(),
      disabled: this.loading
    }, t('delete_button'))));
  }
  buildPayload() {
    return {
      author: this.author || null,
      language: this.language || null
    };
  }
  submit() {
    this.run(this.buildPayload());
  }
  submitDelete() {
    this.run(null);
  }
  run(payload) {
    this.loading = true;
    this.errorMessage = null;
    m.redraw();
    const result = this.attrs.onsubmit(payload);
    if (result && typeof result.then === 'function') {
      result.then(() => this.hide(), error => {
        this.loading = false;
        this.errorMessage = error && error.message || app.translator.trans('champis-keys.forum.key_metadata.error');
        m.redraw();
      });
    } else {
      this.hide();
    }
  }
}
flarum.reg.add('champis-keys', 'forum/components/KeyMetadataModal', KeyMetadataModal);